<template>
  <div
    class="trivia-wrapper"
    :style="{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat'
    }"
  >
    <!-- -------------------- FIXED HEADER -------------------- -->
    <div
      style=" margin: 10px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; padding-top: 20px; margin-top: 0px;"
    >
      <div
        style="display: flex; justify-content: center; align-items: center; gap: 10px;"
      >
        <h3 style="margin: 0px; font-weight: bold; font-size: 16px;">
          Trivia
        </h3>
      </div>
      <h3
        style="text-align: end; margin: 0px; margin-right: 5px; cursor: pointer; font-weight: bold; font-size: 16px;"
        v-on:click="handleBack()"
      >
        X
      </h3>
    </div>

    <!-- -------------------- SCROLLABLE CONTENT -------------------- -->
    <div class="trivia-scroll-area">
      <div
        :style="{
          height: containerHeight + 'vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0px 15px',
          flexDirection: 'column',
          transition: 'height 0.3s ease'
        }"
      >
        <div
          class="card-container"
          @click="peekCard"
          :style="{ minHeight: computedHeight }"
        >
          <!-- Images that flip with the card -->
          <div class="card-content" :class="{ peek: isPeeking }">
            <!-- Clip image -->
            <img
              src="@/assets/flyy_trivia_clip.png"
              alt="clip"
              class="clip-image"
            />
            <!-- Logo image -->
            <img src="@/assets/trivia-logo.png" alt="logo" class="logo-image" />
            <!-- Card flip area -->
            <div class="card">
              <!-- Front side -->
              <div class="front" v-if="isFrontVisible">
                <div class="card-front-content">
                  <div class="main-content">
                    <p
                      :style="{
                        // marginTop: '20px',
                        color: isTitleColour,
                        marginBottom: '0px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        lineHeight: '20px'
                      }"
                      class="title-text"
                      ref="titleText"
                      style="margin-bottom: 0px !important;"
                    >
                      {{ game_data.title }}
                    </p>

                    <p
                      :style="{
                        margin: '0px',
                        color: isDescriptionColour,
                        marginBottom: '0px',
                        lineHeight: '20px',
                        fontSize: '14px'
                      }"
                      class="subtitle-text"
                      ref="subtitleText"
                    >
                      <!-- {{
                        game_data &&
                          game_data.sub_title &&
                          game_data.sub_title.slice(0, 480)
                      }} -->
                      {{ game_data.sub_title }}
                    </p>
                  </div>

                  <div
                    class="tap-instruction"
                    :style="{ height: tapInstructionHeight }"
                  >
                    <p
                      :style="{
                        fontSize: '12px',
                        color: isButtonColour,
                        margin: '0',
                        position: 'absolute',
                        bottom: '20%',
                        left: '37%'
                      }"
                    >
                      Tap to flip
                    </p>
                    <img
                      style="width: 100%;"
                      src="@/assets/flyy_trivia_back_view.png"
                    />
                  </div>
                  <!-- <img
                    style="width: 100%;"
                    src="@/assets/flyy_trivia_back_view.png"
                  /> -->
                </div>
              </div>

              <!-- Back side -->
              <div class="front" v-else>
                <div class="card-front-content">
                  <div class="main-content">
                    <p
                      :style="{
                        fontSize: '15px',
                        color: isButtonColour,
                        lineHeight: '20px',
                        marginBottom: '0px'
                        // marginTop: '20px'
                      }"
                      style="margin-bottom: 0px !important;"
                      class="back-subtitle-text"
                      ref="backSubtitleText"
                    >
                      <!-- {{ game_data.sub_title }} -->
                      {{
                        game_data &&
                          game_data.sub_title &&
                          game_data.sub_title.slice(0, 53)
                      }}
                    </p>

                    <p
                      :style="{
                        color: isDescriptionColour,
                        lineHeight: '22px',
                        fontSize: '14px',
                        margin: '0',
                        marginBottom: '20px'
                      }"
                      class="description-text"
                      ref="descriptionText"
                    >
                      <!-- {{
                        game_data &&
                          game_data.description &&
                          game_data.description.slice(0, 23)
                      }} -->
                      {{ stripHTML(game_data.description) }}
                    </p>
                  </div>
                  <img
                    style="width: 100%; height: 38%;"
                    src="@/assets/flyy_trivia_back_view.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Share + Deeplink Buttons -->
        <div
          v-if="!isFrontVisible"
          class="button-row"
          :style="{
            marginTop: buttonMarginTop + 'px',
            justifyContent: showOnlyOneButton ? 'center' : 'space-between'
          }"
        >
          <button
            v-if="
              game_data.enable_share_link && game_data.share_link_button_text
            "
            @click="handleShareClick"
            class="action-btn"
            :style="{
              backgroundColor: isButtonColour,
              color: isButtonTextColour,
              width: showOnlyOneButton ? '100%' : '50%'
            }"
          >
            {{
              game_data.share_link_button_text.length > 12
                ? game_data.share_link_button_text.substring(0, 12) + ".."
                : game_data.share_link_button_text
            }}
          </button>

          <button
            v-if="game_data.enable_deeplink && game_data.deeplink_button_text"
            @click="handleDeeplinkClick"
            class="action-btn"
            :style="{
              backgroundColor: isButtonColour,
              color: isButtonTextColour,
              width: showOnlyOneButton ? '100%' : '50%'
            }"
          >
            {{
              game_data.deeplink_button_text.length > 12
                ? game_data.deeplink_button_text.substring(0, 12) + ".."
                : game_data.deeplink_button_text
            }}
          </button>
        </div>
      </div>

      <!-- Share Popup (unchanged) -->
      <div
        v-if="showSharePopup"
        style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: flex-end;"
      >
        <div
          style="
       position: relative;
       width: 100%;
       max-width: 400px;
       background: white;
       border-top-left-radius: 20px;
       border-top-right-radius: 20px;
       box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
       text-align: center;
       padding: 20px 0px;
     "
        >
          <!-- Go Back Button (centered above popup) -->
          <button
            @click="showSharePopup = false"
            :style="{
              position: 'absolute',
              top: '-55px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: 'white',
              color: bgTheme,
              border: 'none',
              borderRadius: '50px',
              padding: '11px 16px',
              fontSize: '14px',
              boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
              cursor: 'pointer',
              fontWeight: '700',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '5px'
            }"
          >
            <!-- Chevron Left Icon -->
            <div
              :style="{
                width: '16px',
                height: '16px',
                backgroundColor: bgTheme, // dynamic button color
                WebkitMaskImage:
                  'url(' + asset('chevron-left-red.png') + ')',
                WebkitMaskRepeat: 'no-repeat',
                WebkitMaskPosition: 'center',
                WebkitMaskSize: 'contain',
                maskImage:
                  'url(' + asset('chevron-left-red.png') + ')',
                maskRepeat: 'no-repeat',
                maskPosition: 'center',
                maskSize: 'contain'
              }"
            ></div>
            Go back
          </button>

          <p style="font-weight: bold; margin: 10px 0;">Share via</p>

          <!-- Share Options -->
          <div
            style="display: flex; justify-content: space-evenly; margin-top: 15px;"
          >
            <!-- Facebook -->
            <div @click="getShareMsg(3, 'wa')" style="cursor: pointer; ">
              <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;position: relative; top: 3px; left: 0px;"
                src="@/assets/whatsapp.png"
                alt="back"
                class="logo-image"
              />
              <p style="margin: 5px 0; font-size: 12px;">WhatsApp</p>
            </div>
            <!-- Twitter -->
            <div @click="getShareMsg(2, 'fb')" style="cursor: pointer;">
              <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;  position: relative; top: 3px; left: 0px;"
                src="@/assets/facebook.png"
                alt="back"
                class="logo-image"
              />
              <p style="margin: 5px 0; font-size: 12px;">Facebook</p>
            </div>
            <!-- Gmail -->
            <div @click="getShareMsg(1, 'ig')" style="cursor: pointer;">
              <!-- <img :src="offerData.share_options[2].icon" alt="Gmail" style="width: 40px; height: 40px;" /> -->
              <img
                style="cursor: pointer; width: 35px; height: 35px; margin-bottom: 5px;  position: relative; top: 3px; left: 0px;"
                src="@/assets/instagram.png"
                alt="back"
                class="logo-image"
              />
              <p style="margin: 5px 0; font-size: 12px;">Instagram</p>
            </div>

            <div @click="copyShareLink" style="text-align: center;">
              <div
                :style="{
                  width: '40px',
                  height: '40px',
                  margin: 'auto',
                  backgroundColor: bgTheme, // Background color
                  // backgroundColor: 'red',
                  borderRadius: '50%', // Make it circular
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  cursor: 'pointer',
                  marginBottom: '5px'
                }"
              >
                <div
                  :style="{
                    width: '20px', // Icon size
                    height: '20px',
                    backgroundColor: 'white', // Icon color
                    WebkitMaskImage:
                      'url(' + asset('copy-img1.png') + ')',
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskPosition: 'center',
                    WebkitMaskSize: 'contain',
                    maskImage: 'url(' + asset('copy-img1.png') + ')',
                    maskRepeat: 'no-repeat',
                    maskPosition: 'center',
                    maskSize: 'contain'
                  }"
                ></div>
              </div>

              <p
                style="margin: 0px !important; font-size: 12px; font-weight: bold;"
              >
                Copy link
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- -------------------- FIXED FOOTER -------------------- -->
    <div class="trivia-footer" v-if="isLogoVisible">
      <img
        class="img-fluid"
        style="width: 40px; height: 40px;"
        :src="logoUrl"
      />
    </div>

    <div id="copied-toast" class="copied-toast">Link Copied</div>
  </div>
</template>

<script>
import { asset } from "@/utils/asset";
import { navigateDeeplink } from "@/utils/deeplink";
import axios from "axios";
import backgroundImage from "@/assets/flyy_trivia_back.png";
import { globals } from "@/mixins/globals";

export default {
  name: "quiz-details-custom",
  mixins: [globals],
  props: {
    date: {
      type: String
    }
  },
  data() {
    return {
      isFrontVisible: true,
      alreadyResponded: false,
      selectedOptionId: null,
      game_data: {},
      selectedOptionsMap: {},
      questionIndex: 0,
      backgroundImage,
      isPeeking: false,
      isLogoVisible: false,
      logoUrl: "",
      isDescriptionColour: "",
      isTitleColour: "",
      showSharePopup: false,
      isButtonColour: "",
      isButtonTextColour: "",
      cardHeight: 200, // Default minimum height
      containerHeight: 75, // Default container height in vh
      buttonMarginTop: 20,
      logoMarginTop: 20
    };
  },
  computed: {
    tapInstructionHeight() {
      return this.computedHeight === "230px" ? "52%" : "35%";
    },
    computedHeight() {
      if (
        (this.game_data &&
          this.game_data.sub_title &&
          this.game_data.sub_title.length < 100) ||
        !this.isFrontVisible
      ) {
        return "230px";
      }
      return "320px"; // default
    },
    showOnlyOneButton() {
      const showShare =
        this.game_data.enable_share_link &&
        this.game_data.share_link_button_text !== "";
      const showDeeplink =
        this.game_data.enable_deeplink && this.game_data.deeplink_button_text;
      return (showShare && !showDeeplink) || (!showShare && showDeeplink);
    },
    sdkEvent() {
      return this.$store.state.sdkEvent;
    }
  },
  mounted() {
    this.isDescriptionColour = this.sdkEvent.isDescriptionColour;
    this.isTitleColour = this.sdkEvent.isTitleColour;
    this.isButtonColour = this.sdkEvent.isButtonColour;
    this.isButtonTextColour = this.sdkEvent.isButtonTextColour;

    if (this.sdkEvent.logoUrl !== "") {
      this.isLogoVisible = true;
      this.logoUrl = this.sdkEvent.logoUrl;
    } else {
      this.isLogoVisible = false;
    }
  },
  beforeMount() {
    if (this.$route.params.id) {
      this.$store.state.quizDetailsId = this.$route.params.id;
    }
    this.id = this.$store.state.quizDetailsId;
    this.$store.state.showQuizHistoryMenu = true;
    this.fetchQuizDetails(false);
  },
  methods: {
    calculateCardHeight() {
      this.$nextTick(() => {
        let requiredHeight = 200; // Minimum height
        const availableScreenHeight = window.innerHeight;
        const headerHeight = 80; // Approximate header height
        const buttonHeight = 60; // Button area height (always reserved)
        const logoHeight = 60; // Logo area height (always reserved)
        const extraPadding = 40; // Additional padding for better spacing

        // Calculate available space for the card (always reserve space for buttons and logo)
        const reservedSpace =
          headerHeight + buttonHeight + logoHeight + extraPadding;
        const maxCardHeight = availableScreenHeight - reservedSpace;

        if (this.isFrontVisible) {
          // Calculate height for front side - simplified since CSS now handles line limits
          let frontHeight = 100; // Base padding and margins
          frontHeight += 2 * 24 + 15; // Title: max 2 lines at 20px line-height + margin
          frontHeight += 4 * 24 + 25; // Subtitle: estimated lines + margin
          frontHeight += 40; // "Tap to flip" text height

          requiredHeight = Math.max(requiredHeight, frontHeight);
        } else {
          // Calculate height for back side - simplified since CSS handles line limits
          let backHeight = 90; // Base padding and margins
          backHeight += 2 * 24 + 15; // Subtitle: estimated lines + margin
          backHeight += 6 * 26; // Description: max 6 lines at 22px line-height

          requiredHeight = Math.max(requiredHeight, backHeight);
        }

        // Adjust margins and container height based on content needs for both sides
        if (requiredHeight > maxCardHeight * 0.8) {
          // For long content, reduce margins and use more screen space
          this.buttonMarginTop = 10;
          this.logoMarginTop = 10;
          this.containerHeight = 85; // Use more screen space
          // Limit card height to available space
          this.cardHeight = Math.min(requiredHeight + 20, maxCardHeight);
        } else if (requiredHeight > maxCardHeight * 0.6) {
          // For medium content, slightly reduce margins
          this.buttonMarginTop = 15;
          this.logoMarginTop = 15;
          this.containerHeight = 80;
          this.cardHeight = Math.max(200, requiredHeight + 25);
        } else {
          // For short content, use normal spacing
          this.buttonMarginTop = 20;
          this.logoMarginTop = 20;
          this.containerHeight = 75;
          this.cardHeight = Math.max(200, requiredHeight + 30);
        }
      });
    },
    copyShareLink() {
      const fullText = this.game_data.share_link_text;

      if (fullText) {
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard
            .writeText(fullText)
            .then(() => {
              this.showCopiedToast();
              this.showSharePopup = false;
            })
            .catch(err => {
              console.warn("Clipboard API failed:", err);
              this.fallbackCopyText(fullText);
            });
        } else {
          this.fallbackCopyText(fullText);
        }
      } else {
        console.warn("No share text found to copy.");
      }
    },

    fallbackCopyText(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          this.showCopiedToast();
          this.showSharePopup = false;
        }
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textarea);
    },

    showCopiedToast() {
      const toast = document.getElementById("copied-toast");
      if (toast) {
        toast.style.display = "block";
        setTimeout(() => {
          toast.style.display = "none";
        }, 2000); // Hide after 2 seconds
      }
    },
    handleShareClick() {
      const text = this.game_data.share_link_text;
      const urlMatch = text.match(/https?:\/\/[^\s]+/);
      if (urlMatch) {
        // window.open(urlMatch[0], '_blank');
        this.showSharePopup = !this.showSharePopup;
      } else {
        console.warn("No valid share URL found in share_link_text");
      }
    },
    handleDeeplinkClick() {
      navigateDeeplink(this.$router, this.game_data.deeplink_text);
    },
    stripHTML(text) {
      if (!text) return "";
      var regexTD = /(<([^>]+)>)/gi;
      return text
        .replace(regexTD, "")
        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&nbsp;/g, " ");
    },
    peekCard() {
      this.isPeeking = true;
      this.isFrontVisible = !this.isFrontVisible;

      if (!this.alreadyResponded) {
        this.submitAnswers();
      }

      // Recalculate card height when flipping
      setTimeout(() => {
        this.calculateCardHeight();
      }, 50); // Small delay to ensure DOM is updated

      setTimeout(() => {
        this.isPeeking = false;
      }, 300);
    },
    fetchQuizDetails(valChangeCall) {
      var self = this;
      this.pollId = self.id;
      this.valchangeCall = valChangeCall;

      var url =
        self.$store.getters.flyyDomain + "/v1/start_poll_survey/" + self.id;
      var headers = self.$store.getters.headers;

      axios
        .get(url, { headers })
        .then(resp => {
          if (resp.status == 200) {
            var data = resp.data;
            self.game_data = data;
            self.selectedOptionsMap = {};

            if (data.already_responed && Array.isArray(data.responses)) {
              data.responses.forEach(response => {
                self.selectedOptionsMap[response.question_id] =
                  response.selected_option;
              });
            }

            const currentQuestionId =
              self.game_data.ps_questions[self.questionIndex].id;
            self.selectedOptionId =
              self.selectedOptionsMap[currentQuestionId] || null;

            this.$store.state.quizDetailsTitle = self.game_data.title;

            var now = new Date();
            var end = new Date(self.game_data.starts_at);

            if (self.game_data.is_live) {
              now = new Date();
              end = new Date(self.game_data.ends_at);
            }

            self.endTime = end;
            self.distance = end - now;
            self.showRemaining(valChangeCall);

            this.isDisabled = true;

            // Calculate initial card height after data is loaded
            this.calculateCardHeight();
          } else {
            console.log("Error fetching the Quiz Details");
          }
        })
        .catch(error => {
          console.error("API Error:", error);
        });
    },
    handleBack() {
      var currentUrl = window.location.pathname;
      if (currentUrl == "/play-quiz") {
        this.$store.state.showExitModal = true;
        return;
      }
      this.$router.go(-1);
    },
    tapAction() {
      this.isFrontVisible = !this.isFrontVisible;
    },
    submitAnswers() {
      if (this.game_data.already_responed) return;

      this.alreadyResponded = true;
      const url =
        this.$store.getters.flyyDomain + "/v1/save_poll_survey/" + this.pollId;
      const headers = this.$store.getters.headers;

      const responses = Object.entries(this.selectedOptionsMap).map(
        ([question_id, selected_option]) => ({
          question_id,
          selected_option
        })
      );

      const payload = { responses };

      axios
        .post(url, payload, { headers })
        .then(response => {
          if (response.status === 200) {
            this.game_data.already_responed = true;
            this.game_data.responses = payload.responses;

            if (response.data && response.data.updated_options) {
              response.data.updated_options.forEach((options, idx) => {
                this.game_data.ps_questions[idx].options = options;
              });
            }
          }
        })
        .catch(error => {
          console.error("Error submitting poll survey:", error);
        });
    },
    showRemaining(valChangeCall) {
      // Placeholder: If this method is defined elsewhere, ensure it's included.
      console.log("showRemaining() needs implementation or import.");
    }
  },
  watch: {
    distance(val) {
      if (val <= 0 && !this.valchangeCall) {
        this.fetchQuizDetails(true);
      }
    },
    // Watch for changes in game_data to recalculate card height
    "game_data.title"() {
      this.calculateCardHeight();
    },
    "game_data.sub_title"() {
      this.calculateCardHeight();
    },
    "game_data.description"() {
      this.calculateCardHeight();
    }
  }
};
</script>

<style scoped>
@import "../assets/quiz-styles/quiz-styles.css";
@import "../assets/quiz-styles/bootstrap.css";
@import "../assets/fonts/quiz-fonts/fonts.css";

.trivia-wrapper {
  position: relative;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
}

/* ------------------ FIXED HEADER ------------------ */
.trivia-header {
  position: fixed;
  top: 0;
  width: 100%;
  background: transparent;
  padding: 10px 15px;
  z-index: 20;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-close {
  cursor: pointer;
  font-weight: bold;
  margin-right: 10px;
}

/* ------------------ SCROLLABLE CONTENT ------------------ */
.trivia-scroll-area {
  position: absolute;
  top: 45px;
  bottom: 60px;
  width: 100%;
  /* overflow-y: auto; */
  padding-bottom: 20px;
}

/* ------------------ FIXED FOOTER ------------------ */
.trivia-footer {
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  z-index: 20;
  padding: 5px 0px;
}

/* ==== Card Flip CSS (same as your original) ==== */
.card-container {
  perspective: 1000px;
  position: relative;
  width: 100%;
  max-width: 320px;
  min-height: 200px;
  cursor: pointer;
  transition: height 0.3s ease;
}

.card-content {
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 0.3s ease; /* Reduced from 0.6s to 0.4s */
}

.card-content.peek {
  transform: rotateY(90deg);
}

/* Flip card */
.card {
  width: 100%;
  height: 100%;
  position: relative;
  /* transform-style: preserve-3d; */
  /* background-color: #eeeeee; */
  border-bottom-right-radius: 120px;
}

.front,
.back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  /* border-radius: 20px; */
  overflow: hidden;
}

.front {
  /* background-image: url("~@/assets/flyy_trivia_back_view.png"); */
  /* background-size: cover; */
  /* background-position: center; */
  z-index: 2;
  border-bottom-right-radius: 120px;
  /* background-color: #f8d77c; */
  background-color: #ffd66d;
}

/* .front {
  background-image: url("~@/assets/flyy_trivia_back_view.png");
  background-size: cover; 
  background-position: bottom; 
  background-repeat: no-repeat;
} */

/* Updated front content styling with flexbox layout */
.card-front-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  height: 100%;
  /* padding: 45px 30px 20px 30px;  */
  box-sizing: border-box;
  padding-top: 40px;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 8px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  /* min-height: 150px; */
  overflow-y: auto;
  padding: 10px 20px 20px 20px;
}

.tap-instruction {
  /* flex-shrink: 0; */
  /* margin-top: auto; */
  /* padding: 20px; */
  position: relative;
  /* background-color: red; */
  height: 35%;
}

.card-back-content {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  flex-direction: column;
  padding: 25px 20px;
  box-sizing: border-box;
  word-wrap: break-word;
  overflow-wrap: break-word;
  gap: 8px;
}

/* Positioned images (clip and logo) */
.clip-image {
  width: 25px;
  height: 55px;
  position: absolute;
  bottom: 88%;
  left: 12%;
  z-index: 3;
}

.logo-image {
  width: 100px;
  height: 100px;
  position: absolute;
  bottom: 87%;
  left: 35%;
  z-index: 3;
}
.button-row {
  width: 90%;
  display: flex;
  align-items: center;
  gap: 5px;
}

.action-btn {
  padding: 10px;
  border-radius: 20px;
  font-weight: bold;
  border: none;
  cursor: pointer;
}

.share-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.share-box {
  width: 100%;
  max-width: 400px;
  background: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 20px 0;
  position: relative;
}

.share-back-btn {
  position: absolute;
  top: -55px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 11px 16px;
  border-radius: 50px;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.share-img {
  width: 35px;
  height: 35px;
}

.copied-toast {
  position: fixed;
  bottom: 10%;
  display: none;
  width: 100px;
  background: rgba(0, 0, 0, 0.3);
  color: white;
  padding: 5px;
  text-align: center;
  border-radius: 10px;
}
</style>
